import { useRouteParams } from './useRouteParams';

export const useLocalStorageKey = () => {
  const { clientId } = useRouteParams();

  return `permanent-${window.ADV.util.env('isAdviserArea')}-${clientId}-FinancialPlan`;
};
